import React, { Component } from 'react';

export default class Display_Layout_Cell_Label extends Component {
	constructor(props) {
		super(props);

		this.state = {}
	}

	render() {
		let header_font_size = (0.133) * this.props.cell_width + 2;

		let report_name = '';

		switch (this.props.name) {
			case 'trend':
				report_name = this.props.receiver.getString('trend_graph');
				break;
			case 'energy_management':
				report_name = this.props.receiver.getString('energy_management');
				break;
			case 'water_management':
				report_name = this.props.receiver.getString('water_management');
				break;
			case 'op_info':
				report_name = this.props.receiver.getString('operation_info_report');
				break;
			case 'error_info':
				report_name = this.props.receiver.getString('err_reporting_report');
				break;
			default:
		}

		return (
			<div>
				<span style={{ textAlign: 'center', fontSize: header_font_size, display: 'inline-block', whiteSpace: 'nowrap' }}>{report_name}</span>
			</div>
		)
	}
}